<template>
  <div class="flex flex-col items-center overflow-hidden xl:w-1450 xl:mx-auto">
    <ul
      ref="testimonialsContainer"
      class="testimonial flex justify-evenly hide-scrollbar mt-16 lg:mt-25 p-1"
      @touchstart="
        (e) => {
          touchStart = e.changedTouches[0].screenX;
        }
      "
      @touchend="
        (e) => {
          touchEnd = e.changedTouches[0].screenX;
          touchEnd < touchStart ? scroll(-1) : scroll(1);
        }
      "
    >
      <li v-for="(testimonial, index) in testimonials" :key="'testimonial-' + index">
        <Card
          :id="'card-' + index"
          class="testimonial__card flex flex-col justify-between p-24"
          :class="index + carouselIndex === 7 ? 'testimonial__active-card' : ''"
        >
          <div>
            <LeftQuote />
            <p class="text-s md:text-m mt-8">{{ testimonial.text }}</p>
          </div>
          <div>
            <h3 class="testimonial__name-text font-medium text-m2">{{ testimonial.name }}</h3>
            <p class="text-s">{{ testimonial.location }}</p>
          </div>
        </Card>
      </li>
    </ul>
    <div class="mt-36">
      <button @click="scroll(1)"><BackSmallIcon :width="24" :height="24" color="#4B4C52" /></button>
      <button class="ml-48" @click="scroll(-1)"><DisclosureSmallIcon :width="24" :height="24" color="#4B4C52" /></button>
    </div>
  </div>
</template>

<script lang="ts">
import { parentTestimonials } from '../../helpers/upgrade';

import Card from '../../components/card/Card.vue';

import BackSmallIcon from '@/graphics/icons/BackSmallIcon.vue';
import DisclosureSmallIcon from '@/graphics/icons/DisclosureSmallIcon.vue';
import LeftQuote from '../../icons/LeftQuote.vue';

export default {
  name: 'TestimonialsCarousel',
  components: {
    Card,

    BackSmallIcon,
    DisclosureSmallIcon,
    LeftQuote,
  },
  data(): any {
    return {
      carouselIndex: 0,
      touchStart: 0,
      touchEnd: 0,
    };
  },
  computed: {
    testimonials(): Array<Object> {
      return parentTestimonials.concat(parentTestimonials, parentTestimonials);
    },
    numItems(): Number {
      return parentTestimonials.length;
    },
    carousel(): any {
      return this.$refs.testimonialsContainer;
    },
  },
  methods: {
    updateCarouselIndex() {
      this.carouselIndex = parseInt(getComputedStyle(this.carousel).getPropertyValue('--carousel-index'), 10);
    },
    scroll(incr: 1 | -1) {
      if (this.carouselIndex === this.numItems * incr) {
        this.carousel.style.transition = '0s';
        this.carousel.style.setProperty('--carousel-index', 0);
        this.updateCarouselIndex();
      }

      this.carousel.style.transition = 'transform 250ms ease-in-out';

      this.carousel.style.setProperty('--carousel-index', this.carouselIndex + incr);
      this.updateCarouselIndex();
    },
  },
};
</script>
